import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import Input from '../../../common/input';
import * as shapes from '../../../register/shapes';
import { trimFunction } from '../../../common/trimData';
import CurrencyInput from '../../../common/currencyInput';
import AdminActionButton from '../../shared/Buttons/AdminActionButton';

const maxSum = sum => value => (value > sum * 100 ? sum * 100 : value);

const Form = ({ pristine, submitting, valid, handleSubmit, processCharge, currency }) => (
  <form className="u-mt- u-mb">
    <fieldset disabled={submitting}>
      <div className="layout u-mt-">
        <div className="layout__item u-1/2-large-and-up">
          <span className="c-label-new">{t('subscription:description_label')}</span>
          <Input className="c-input" name="desc" type="text" placeholder={t('subscription:enter_description_placeholder')} maxLength={255} />
        </div>
        <div className="layout__item u-1/2-large-and-up">
          <span className="c-label-new">{t('subscription:price_label')}</span>
          <CurrencyInput className="c-input" name="price" currency={currency} format={maxSum(100000)} />
        </div>
      </div>
      <AdminActionButton
        type="submit"
        className="c-btn u-mt-"
        disabled={pristine || !valid}
        name="chargeCB"
        onClick={handleSubmit(trimFunction(processCharge))}
      >
        <span className="c-btn__text">{t('subscription:charge_button')}</span>
      </AdminActionButton>
    </fieldset>
  </form>
);

Form.propTypes = {
  handleSubmit: shapes.handler,
  processCharge: shapes.handler,
  pristine: shapes.pristine,
  submitting: shapes.submitting,
  valid: shapes.valid,
  currency: shapes.string.isRequired,
};

Form.defaultProps = {
  handleSubmit: () => null,
  processCharge: () => null,
  pristine: false,
  submitting: false,
  valid: false,
  barbers: [],
};

export default Form;
